import axios from "../../../core/api/http-common";
import moment from "moment";
import DeviceInformation from "../../../core/helpers/device_informations";

const REGISTER = "/auth/register";
const COMPLETE = "/auth/register/complete";
const ON_NEW_REGISTER = "/auth/new/register";
const LOGIN = "/auth/login";
const ON_GET_ME = "/auth/me";
const REFRESH = "/auth/refresh";
const LOGOUT = "/auth/logout";

export async function login(data) {
  //
  // const deviceInfo = await DeviceInformation.collectDeviceInfo();
  // console.log({ deviceInfo });

  //
  const dates = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const location = "N/A";
  const latitude = "N/A";
  const longitude = "N/A";
  const device = "PC";
  const ip_address = "N/A";
  const operating_system = "N/A";
  const navigator = "N/A";
  //
  const _data = {
    mail: data.mail,
    password: data.password,
    dates: dates,
    is_channel: "webApp",
    location: location,
    latitude: latitude,
    longitude: longitude,
    device: device,
    ip_address: ip_address,
    operating_system: operating_system,
    navigator: navigator,
  };
  return new Promise(async (resolve, reject) => {
    await axios
      .post(LOGIN, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export const onGetMe = (axiosPrivate) => {
  return axiosPrivate.get(ON_GET_ME, { withCredentials: true });
};
//
export function onInscription(data) {
  const _data = {
    firstname: data.firstname,
    lastname: data.lastname,
    mail: data.mail,
    password: data.password,
    sys_role: "student",
  };
  return new Promise(async (resolve, reject) => {
    await axios
      .post(REGISTER, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onCompleteInscription(axiosPrivate, data) {
  const _data = {
    register_code: data?.register_code,
    id: data?.user_id,
    firstname: data?.firstname,
    lastname: data?.lastname,
    gender: data?.gender,
    mail: data?.mail,
    birth: moment(data?.birth).format("YYYY-MM-DD HH:mm:ss"),
    birth_location: data?.birth_location,
    origin_country: data?.origin_country,
    profession: data?.profession,
    stream: data?.stream,
    program_language: data?.program_language,
    expectations: data?.expectations,
    is_completed: true,
    //
    inscription_id: data?.inscription_id,
    //
    dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    is_channel: "web app",
    location: "N/A",
    latitude: "N/A",
    longitude: "N/A",
    device: "PC",
    ip_address: "127.0.0.1",
    operating_system: "Linux",
    navigator: "Chrome",
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(COMPLETE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onNewSchoolInscription(axiosPrivate, data) {
  const _data = {
    stream: data?.stream,
    program_language: data?.program_language,
    expectations: data?.expectations,
    //
    user_id: data?.user_id,
    //
    dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    is_channel: "web app",
    location: "N/A",
    latitude: "N/A",
    longitude: "N/A",
    device: "PC",
    ip_address: "127.0.0.1",
    operating_system: "Linux",
    navigator: "Chrome",
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_NEW_REGISTER, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
